import * as moment from "moment";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { NumericFormat } from "react-number-format";
import { useHistory, useLocation } from 'react-router-dom';
import ReactToPrint from "react-to-print";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  Button,
  Icon
} from "../../components/Component";
import Table from "../../components/react-table/Table";
import { GET } from "../../helper/api";
import { getToken } from "../../helper/auth";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";


const PNContainerDownFee = () => {
  const printRef = useRef();
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [data, setData] = useState([]);
  const [summary, setSummary] = useState({});

  const [loading, setLoading] = useState(false);
  const [smOption, setSmOption] = useState(false);

  const [filter, setFilter] = useState({
    monthYear: searchParams.get('monthYear') || moment().format("YYYY-MM"),
  });

  const colTable = useMemo(() => [
    {
      Header: "Nội dung",
      accessor: (item) => item?.pnStaff?.name,
    },
    {
      Header: "Đơn giá(đ)",
      accessor: (item) => <NumericFormat
        value={item.unitPrice}
        displayType={"text"}
        decimalScale={2}
        thousandSeparator={","}
        thousandsGroupStyle="thousand"
      />
    },
    {
      Header: "Số lượng(cont)",
      accessor: (item) => <NumericFormat
        value={item.quantity}
        displayType={"text"}
        decimalScale={2}
        thousandSeparator={","}
        thousandsGroupStyle="thousand"
      />
    },
    {
      Header: "Số tiền(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        value={item.amount}
        displayType={"text"}
        decimalScale={2}
        thousandSeparator={","}
        thousandsGroupStyle="thousand"
      />,
    },
  ], [])

  // Changing state value when searching name
  useEffect(() => {
    const newParams = new URLSearchParams({
      ...(filter.userId ? { userId: filter.userId } : {}),
      ...(filter.monthYear ? { monthYear: filter.monthYear } : {}),
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    })

    setLoading(true);
    setData([]);
    let params = {
      monthYear: filter.monthYear
    };

    GET(`/pn-customer-money-flow/container-down-fee`, params, true)
      .then(({ data: { rows, summary } }) => {
        setData(rows);
        setSummary(summary)
      })
      .finally(() => {
        setLoading(false);
      });
  }, [filter]);



  const exportExcel = () => {
    const params = new URLSearchParams({
      ...(filter.monthYear ? { monthYear: filter.monthYear } : {}),
      token: getToken(),
    })
    const url = `${process.env.REACT_APP_API_URL}/api/v1/pn-customer-money-flow/container-down-fee-excel?${params.toString()}`;
    window.open(url, '_blank')
  };


  return (
    <React.Fragment>
      <Head title="Quản lý tiền tài chi Phương Nam"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              {/* <BlockTitle page>Quản lý thu chi Phương Nam</BlockTitle> */}
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div className="form-control-wrap">
                        <input
                          type="month"
                          className="form-control  border-primary"
                          value={filter.monthYear}
                          onChange={(e) =>
                            setFilter({
                              ...filter,
                              monthYear: e.target.value,
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div>
                        <ReactToPrint
                          trigger={() => <Button color="secondary">In</Button>}
                          content={() => printRef.current}
                          pageStyle={``}
                        />
                        <Button
                          className={'ml-3'}
                          color="secondary"
                          onClick={exportExcel}
                        >
                          <span>Xuất excel</span>
                        </Button>
                      </div>

                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="my-3" ref={printRef}>
                  <h5 className="text-center mt-2 mb-2">Báo cáo phí hạ container tháng {moment(filter.monthYear, 'YYYY-MM').format('MM-YYYY')}</h5>
                  <Table
                    loading={loading}
                    columns={colTable}
                    data={data}
                    notShowPagi={true}
                    headerRow={< tr className="nk-tb-item odd font-weight-bold">
                      <td colSpan={2}>
                        Tổng cộng
                      </td>
                      <td>
                        <NumericFormat
                          value={summary?.quantity}
                          displayType={"text"}
                          decimalScale={2}
                          thousandSeparator={","}
                          thousandsGroupStyle="thousand"
                        />
                      </td>
                      <td>
                        <NumericFormat
                          value={summary?.amount}
                          displayType={"text"}
                          decimalScale={2}
                          thousandSeparator={","}
                          thousandsGroupStyle="thousand"
                        />
                      </td>
                    </tr>}
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default PNContainerDownFee;
